import axios from "axios";
import { setAreas, setMerchantProductCategories, setMerchantProductCategoryHierarchy, setProductCategories, setProductCategoryHierarchy, setMerchantCategories, setSystemMenus, setStoreSections, setStoreBrands, setSuppliers } from "../store/reducers/globalData";
import { store } from "../store";
import { alert } from "./alert";
import { asyncRequest } from "./network";

// 系统菜单
export const getSystemMenus = (force = false) => {
  if (store.getState().globalData.systemMenus && !force) return;

  axios
    .get("/system/menu/all")
    .then((res) => {
      const { code, msg, data } = res.data;
      if (code === 1) {
        const menus = JSON.parse(JSON.stringify(data));

        menus.sort((a, b) => b.order - a.order);

        const levels = [];

        for (let i = 0; i < menus.length; i++) {
          const level = (menus[i].level || 1) - 1;
          if (!levels[level]) {
            levels[level] = [];
          }

          levels[level].push(menus[i]);
        }

        for (let i = levels.length - 1; i > 0; i--) {
          for (let j = 0; j < levels[i].length; j++) {
            const parentGroup = levels[i - 1];
            const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

            if (!parent.children) {
              parent.children = [];
            }

            parent.children.push(levels[i][j]);
          }
        }

        store.dispatch(setSystemMenus({ data, hierarchy: levels[0] }));
      } else {
        alert(msg);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

// 商品分类
export const getProductCategories = (force = false) => {
  if (store.getState().globalData.productCategories && !force) return;

  axios
    .get("/store/category/all")
    .then((res) => {
      const { code, msg, data } = res.data;
      if (code === 1) {
        store.dispatch(setProductCategories(data));
        const menus = JSON.parse(JSON.stringify(data));
        menus.sort((a, b) => b.order - a.order);
        const levels = [];

        for (let i = 0; i < menus.length; i++) {
          const level = (menus[i].level || 1) - 1;
          if (!levels[level]) {
            levels[level] = [];
          }

          levels[level].push(menus[i]);
        }

        for (let i = levels.length - 1; i > 0; i--) {
          for (let j = 0; j < levels[i].length; j++) {
            const parentGroup = levels[i - 1];
            const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

            if (!parent.children) {
              parent.children = [];
            }

            parent.children.push(levels[i][j]);
          }
        }

        store.dispatch(setProductCategoryHierarchy(levels[0]));
      } else {
        alert(msg);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

export const getMerchantCategories = async (force = false) => {
  if (store.getState().globalData.merchantCategories.length && !force) return;

  const { data } = await asyncRequest({
    method: "get",
    path: "/merchant/category/all",
  });

  store.dispatch(setMerchantCategories(data));
};

export const getMerchantProductCategories = (force = false) => {
  if (store.getState().globalData.merchantProductCategories && !force) return;

  axios
    .get("/store/category/my")
    .then((res) => {
      const { code, msg, data } = res.data;
      if (code === 1) {
        store.dispatch(setMerchantProductCategories(data));

        const menus = JSON.parse(JSON.stringify(data));

        menus.sort((a, b) => b.order - a.order);

        const levels = [];

        for (let i = 0; i < menus.length; i++) {
          const level = (menus[i].level || 1) - 1;
          if (!levels[level]) {
            levels[level] = [];
          }

          levels[level].push(menus[i]);
        }

        for (let i = levels.length - 1; i > 0; i--) {
          for (let j = 0; j < levels[i].length; j++) {
            const parentGroup = levels[i - 1];
            const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

            if (!parent.children) {
              parent.children = [];
            }

            parent.children.push(levels[i][j]);
          }
        }

        store.dispatch(setMerchantProductCategoryHierarchy(levels[0]));
      } else {
        alert(msg);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

export const getAreas = (force = false) => {
  if (store.getState().globalData.areas && !force) return;
  axios
    .get("/system/city/all")
    .then((res) => {
      const { code, msg, data } = res.data;
      if (code === 1) {
        const menus = JSON.parse(JSON.stringify(data));
        menus.sort((a, b) => b.order - a.order);
        const levels = [];
        const map = {};
        for (let i = 0; i < menus.length; i++) {
          map[menus[i].id] = menus[i].name;
          const level = (menus[i].level || 1) - 1;
          if (!levels[level]) {
            levels[level] = [];
          }

          levels[level].push(menus[i]);
        }

        for (let i = levels.length - 1; i > 0; i--) {
          for (let j = 0; j < levels[i].length; j++) {
            const parentGroup = levels[i - 1];
            const parent = parentGroup.find((p) => p.id === levels[i][j].pid);

            if (!parent.children) {
              parent.children = [];
            }

            parent.children.push(levels[i][j]);
          }
        }
        store.dispatch(
          setAreas({
            areas: data,
            areaHierarchy: levels[0],
            areaMap: map,
          })
        );
      } else {
        alert(msg);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

export async function getStoreSections(force = false) {
  if (store.getState().globalData.storeSections.length && !force) return;
  const { data } = await asyncRequest({
    path: "/store/section/list",
    data: {
      page: 0,
      size: 1000,
    },
  });

  store.dispatch(setStoreSections(data));
}

export async function getStoreBrands(force = false) {
  if (store.getState().globalData.storeBrands.length && !force) return;
  const { data } = await asyncRequest({
    path: "/store/brand/list",
    data: {
      page: 0,
      size: 1000,
    },
  });

  store.dispatch(setStoreBrands(data));
}

export async function getSuppliers(force = false) {
  if (store.getState().globalData.suppliers.length && !force) return;
  const { data } = await asyncRequest({
    path: "/store/supplier/list",
    data: {
      page: 0,
      size: 1000,
    },
  });

  store.dispatch(setSuppliers(data));
}